const doc = [({"da":({"js":({"school_classes":({"select":({"choose_school_class":"Vælg skoleklasse"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;